import { z } from 'zod';
export var LanguageType;
(function (LanguageType) {
    LanguageType["GREEK"] = "Greek";
    LanguageType["HEBREW"] = "Hebrew";
    LanguageType["ARAMAIC"] = "Aramaic";
})(LanguageType || (LanguageType = {}));
export const LanguageTypeSchema = z.enum(['Greek', 'Hebrew', 'Aramaic']);
/**
 * Strong's number definition from the concordance.
 */
export const StrongsNumberSchema = z.object({
    name: z.string(), // The Strong's number (e.g., "G26", "H3068")
    language: LanguageTypeSchema,
    number: z.number().int(), // Numeric part only
    phonetic: z.string(), // Transliteration
    native: z.string(), // Original language text
    text: z.string(), // English definition
});
/**
 * Strong's definition as stored in vector database.
 */
export const StrongsChunkSchema = z.object({
    id: z.string(),
    text: z.string(),
    metadata: z.object({
        type: z.literal('strongs_definition'),
        number: z.string(), // "G26", "H1234"
        word: z.string(),
        language: LanguageTypeSchema,
        definition: z.string(),
        pronunciation: z.string().optional(),
        native: z.string().optional(),
        relatedWords: z.array(z.string()).optional(),
        relatedConcepts: z.array(z.string()).optional(),
        frequency: z.number().int().nonnegative().optional(),
    }),
});
/**
 * Parse a Strong's number string into its components.
 */
export function parseStrongsNumber(str) {
    const match = str.match(/^([GH])(\d+)$/i);
    if (!match)
        return null;
    return {
        language: match[1].toUpperCase() === 'G' ? LanguageType.GREEK : LanguageType.HEBREW,
        number: parseInt(match[2], 10),
    };
}
/**
 * Format a Strong's number for display.
 */
export function formatStrongsNumber(language, number) {
    const prefix = language === LanguageType.GREEK ? 'G' : 'H';
    return `${prefix}${number}`;
}
//# sourceMappingURL=strongs-number.js.map